// Soluscent: browser back/forward (and iOS/Android BFCache restoration in
// general) can hand the page back exactly as it was rendered before the
// customer navigated away -- including a cart-icon-bubble count, cart
// drawer contents, and Cart Page item/footer markup that no longer match
// the real Shopify cart, if the cart changed on an intermediate page (e.g.
// removing an item on /cart, then pressing Back). No JS re-runs on a BFCache
// restore, so nothing here fixes itself without an explicit resync.
//
// This performs exactly one round trip -- the same no-op
// `{ updates: {} }` trick used elsewhere in this codebase for safe
// resyncs -- and patches whichever of cart-icon-bubble / cart-drawer /
// main-cart-items / main-cart-footer are actually present on the current
// page, using their real section ids and the exact same
// full-section-innerHTML-swap approach already used by CartDrawer.
// renderContents() and the Bug-2 empty-cart fix in cart.js, so this never
// depends on stale non-empty markup surviving under a CSS toggle alone.
//
// The result is then published as a normal PUB_SUB_EVENTS.cartUpdate
// event (source: 'history-restore') so existing subscribers -- notably
// soluscent-shipping-protection.js's own Delivery Protection reconcile()
// -- cascade from this single fetch instead of running their own parallel
// pageshow listener (which soluscent-shipping-protection.js used to do;
// removed there in favor of this shared entry point).
(function () {
  var resyncInFlight = false;

  function getSectionInnerHTML(html, selector) {
    if (!html) return null;
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  function getSectionIds() {
    var ids = [];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');

    var mainCartItemsRoot = document.getElementById('main-cart-items');
    var mainCartFooterRoot = document.getElementById('main-cart-footer');
    if (mainCartItemsRoot && mainCartItemsRoot.dataset.id) ids.push(mainCartItemsRoot.dataset.id);
    if (mainCartFooterRoot && mainCartFooterRoot.dataset.id) ids.push(mainCartFooterRoot.dataset.id);

    return ids;
  }

  function applySections(state) {
    if (!state || !state.sections) return;

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var bubbleInner = getSectionInnerHTML(state.sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleInner !== null) {
        var bubbleTarget = bubble.querySelector('.shopify-section') || bubble;
        bubbleTarget.innerHTML = bubbleInner;
      }
    }

    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var cartDrawerInner = getSectionInnerHTML(state.sections['cart-drawer'], '#CartDrawer');
      var cartDrawerRoot = document.getElementById('CartDrawer');
      if (cartDrawerInner !== null && cartDrawerRoot) cartDrawerRoot.innerHTML = cartDrawerInner;
      cartDrawerEl.classList.toggle('is-empty', state.item_count === 0);
    }

    var cartItemsEl = document.querySelector('cart-items');
    var mainCartItemsRoot = document.getElementById('main-cart-items');
    if (cartItemsEl && mainCartItemsRoot && mainCartItemsRoot.dataset.id) {
      var sourceCartItemsHTML = state.sections[mainCartItemsRoot.dataset.id];
      if (sourceCartItemsHTML) {
        var sourceCartItems = new DOMParser().parseFromString(sourceCartItemsHTML, 'text/html').querySelector('cart-items');
        if (sourceCartItems) cartItemsEl.innerHTML = sourceCartItems.innerHTML;
      }
      cartItemsEl.classList.toggle('is-empty', state.item_count === 0);
    }

    var mainCartFooterRoot = document.getElementById('main-cart-footer');
    if (mainCartFooterRoot && mainCartFooterRoot.dataset.id) {
      var sourceFooterHTML = state.sections[mainCartFooterRoot.dataset.id];
      if (sourceFooterHTML) {
        var sourceFooter = new DOMParser().parseFromString(sourceFooterHTML, 'text/html').getElementById('main-cart-footer');
        if (sourceFooter) mainCartFooterRoot.innerHTML = sourceFooter.innerHTML;
      }
      mainCartFooterRoot.classList.toggle('is-empty', state.item_count === 0);
    }
  }

  function resync() {
    if (resyncInFlight) return;

    var sectionIds = getSectionIds();
    if (sectionIds.length === 0) return;

    resyncInFlight = true;

    fetch(
      routes.cart_update_url,
      Object.assign({}, fetchConfig(), {
        body: JSON.stringify({ updates: {}, sections: sectionIds, sections_url: window.location.pathname }),
      })
    )
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var state = JSON.parse(text);
        applySections(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'history-restore', cartData: state });
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        resyncInFlight = false;
      });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resync();
  });
})();
